import { Divider } from "@mui/material";
import * as React from "react";
import { useContext } from "react";
import { FilteredPrivateChatsContext } from "hhn-commons";
import { GroupChatListPanelHeaderWrapper } from "../group/patient/PatientChats.styles";
import { GroupChatListPanelHeader } from "../GroupChatListPanelHeader";
import { PrivateChatList } from "./PrivateChatList";

type PrivateChatListSearchViewProps = {
  selectedChatId?: string;
};

export const PrivateChatListSearchView = ({
  selectedChatId,
}: PrivateChatListSearchViewProps) => {
  const { chatData, isChatLoading, fetchChats } = useContext(
    FilteredPrivateChatsContext,
  );

  return (
    <>
      <Divider />
      <GroupChatListPanelHeaderWrapper>
        <GroupChatListPanelHeader
          unreadChatCount={chatData?.unreadChatCount || 0}
          searchResultCount={chatData?.searchMatchCount}
          listSize={(chatData?.chats || []).length}
        />
      </GroupChatListPanelHeaderWrapper>
      <Divider />
      <PrivateChatList
        chats={chatData?.chats || []}
        selectedChatId={selectedChatId}
        isChatLoading={isChatLoading}
        fetchChatList={fetchChats}
        isMoreChats={chatData?.hasNext}
      />
    </>
  );
};
